// src/pages/Users.tsx
import React, { useEffect, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Chip, Box, CircularProgress } from '@mui/material';
import { fetchUsers } from '../services/userService';
import { ManagedUser } from '../types/auth';

const statusChip = (status: ManagedUser['status']) => {
    switch (status) {
        case 'Active':
            return <Chip label={status} color="success" />;
        case 'Pending':
            return <Chip label={status} color="warning" />;
        case 'Banned':
            return <Chip label={status} color="error" />;
        default:
            return <Chip label={status} />;
    }
}

const Users: React.FC = () => {
    const [users, setUsers] = useState<ManagedUser[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getUsers = async () => {
            setLoading(true);
            try {
                const userList = await fetchUsers();
                setUsers(userList);
            } catch (err) {
                console.error('Failed to fetch users:', err);
            } finally {
                setLoading(false);
            }
        };
        getUsers();
    }, []);

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>
    }

  return (
    <Box>
        <Typography variant="h4" gutterBottom>
            User Management
        </Typography>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created At</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {users.map((user) => (
                    <TableRow
                    key={user.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">
                        {user.id}
                    </TableCell>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.role}</TableCell>
                    <TableCell>{statusChip(user.status)}</TableCell>
                    <TableCell>{user.createdAt}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
  );
};

export default Users;